import React, { createContext, useContext, useEffect, useState } from 'react';
import { translations } from '../data/mockData';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within LanguageProvider');
  }
  return context;
};

const RTL_LANGS = new Set(['ar']);

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    try {
      const saved = localStorage.getItem('gv_language');
      return saved && translations[saved] ? saved : 'ru';
    } catch (_) {
      return 'ru';
    }
  });

  // English fallback ensures Arabic doesn't break UI where translations are missing
  const t = translations[language] || translations.en || translations.ru;

  useEffect(() => {
    const isRtl = RTL_LANGS.has(language);
    document.documentElement.dir = isRtl ? 'rtl' : 'ltr';
    document.documentElement.lang = language;
    document.documentElement.classList.toggle('rtl', isRtl);
    try { localStorage.setItem('gv_language', language); } catch (_) {}
  }, [language]);

  const changeLanguage = (lang) => {
    if (translations[lang]) {
      setLanguage(lang);
    }
  };

  return (
    <LanguageContext.Provider value={{ language, changeLanguage, t, isRtl: RTL_LANGS.has(language) }}>
      {children}
    </LanguageContext.Provider>
  );
};
